import React, { useEffect } from "react";
import { AbsoluteContainer, FormContainer } from "./hubspotForm.styles";
import { useLocation } from "react-use";

const HubspotForm = () => {
  const location = useLocation();

  useEffect(() => {
    const loadHubspotForm = () => {
      const hbspt = (window as any).hbspt;
      if (hbspt) {
        hbspt.forms.create({
          region: "na1",
          portalId: "22562698",
          formId: "ed5cf087-8b7d-420d-a8b8-d7b557570294",
          target: "#hubspotForm",
          locale: "pt",
        });
      }
    };

    if (!(window as any).hbspt) {
      const script = document.createElement("script");
      script.src = "https://js.hsforms.net/forms/v2.js";
      script.async = true;
      script.onload = loadHubspotForm;
      document.body.appendChild(script);
    } else {
      loadHubspotForm();
    }

    return () => {
      const formContainer = document.querySelector("#hubspotForm");
      if (formContainer) {
        formContainer.innerHTML = "";
      }
    };
  }, [location]);

  return (
    <FormContainer>
      <div id="hubspotForm" />
      <AbsoluteContainer />
    </FormContainer>
  );
};

export default HubspotForm;
